import { render, staticRenderFns } from "./MailOrder.vue?vue&type=template&id=86d944f6&"
import script from "./MailOrder.vue?vue&type=script&lang=js&"
export * from "./MailOrder.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports